exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Repeat-module__statistics__difficult_p__3K_K9 {\r\n    color: #fc6262;\r\n    font-size: 30px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n}", ""]);

// exports
exports.locals = {
	"statistics__difficult_p": "Repeat-module__statistics__difficult_p__3K_K9"
};